import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import { fetchTestimonials, createTestimonial, updateTestimonial, deleteTestimonial } from '../utils/testimonialsApi';
import './AdminGallery.css';

export default function AdminTestimonials() {
    const [testimonials, setTestimonials] = useState([]);
    const [name, setName] = useState('');
    const [role, setRole] = useState('');
    const [text, setText] = useState('');
    
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const loadTestimonials = async () => {
        const data = await fetchTestimonials();
        setTestimonials(data || []);
    };

    useEffect(() => {
        loadTestimonials();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setMessage({ type: '', text: editingId ? 'Updating testimonial...' : 'Saving testimonial...' });
            
            if (editingId) {
                await updateTestimonial(editingId, { name, role, text });
                setMessage({ type: 'success', text: 'Success! Testimonial updated.' });
                setEditingId(null);
            } else {
                await createTestimonial({ name, role, text });
                setMessage({ type: 'success', text: 'Success! Testimonial added.' });
            }
            
            setName('');
            setRole('');
            setText('');
            loadTestimonials();
        } catch (error) {
            setMessage({ type: 'danger', text: `Failed: ${error.message}` });
        } finally {
            setLoading(false);
        }
    }

    const handleEdit = (item) => {
        setEditingId(item.id);
        setName(item.name || '');
        setRole(item.role || '');
        setText(item.text || '');
    }

    const cancelEdit = () => {
        setEditingId(null);
        setName('');
        setRole('');
        setText('');
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this testimonial?")) return;
        try {
            await deleteTestimonial(id);
            setMessage({ type: 'success', text: 'Testimonial deleted!' });
            loadTestimonials();
        } catch(error) {
            setMessage({ type: 'danger', text: 'Failed to delete.' });
        }
    }

    return (
        <div className="admin-gallery-container pt-5 pb-5">
            <div className="container">
                <AdminNavbar />

                {message.text && (
                    <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
                        {message.text}
                        <button type="button" className="close" onClick={() => setMessage({type: '', text: ''})} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}

                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <div className="admin-card upload-card">
                            <h4>{editingId ? 'Edit Testimonial' : 'Add New Testimonial'}</h4>
                            <p className="text-muted" style={{fontSize: '0.9rem'}}>{editingId ? 'Update this review.' : 'Add a new review to the public Testimonials section.'}</p>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                    <label>Name</label>
                                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Ahmed M." required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Role</label>
                                    <input type="text" className="form-control" value={role} onChange={(e) => setRole(e.target.value)} placeholder="e.g. Parent of Grade 4 Student" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Quote / Review</label>
                                    <textarea className="form-control" rows="4" value={text} onChange={(e) => setText(e.target.value)} placeholder="The dedication of the teachers here is unmatched..." required />
                                </div>
                                
                                <button type="submit" className="upload-btn w-100 mt-4" disabled={loading}>
                                    {loading ? 'Saving...' : editingId ? 'Update Testimonial' : 'Add Testimonial'}
                                </button>
                                {editingId && (
                                    <button type="button" onClick={cancelEdit} className="btn btn-secondary w-100 mt-2 font-weight-bold" disabled={loading}>
                                        Cancel Edit
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="admin-card">
                            <h4>Current Testimonials</h4>
                            <div className="row admin-grid mt-4">
                                {testimonials.map((item) => (
                                    <div className="col-md-6 mb-4" key={item.id}>
                                        <div className="card shadow-sm border-0 h-100 p-3 text-center">
                                            <div className="card-body">
                                                <i className="fa fa-quote-left text-primary fa-2x mb-2"></i>
                                                <p className="card-text text-muted mb-3" style={{ fontSize: "0.95rem", fontStyle: "italic" }}>
                                                  "{item.text}"
                                                </p>
                                                <h6 className="font-weight-bold mb-1">{item.name}</h6>
                                                <small className="text-muted">{item.role}</small>
                                                
                                                <div className="d-flex justify-content-between mt-4" style={{gap: '10px'}}>
                                                    <button onClick={() => handleEdit(item)} className="btn btn-sm btn-outline-primary flex-fill font-weight-bold">
                                                        ✏️ Edit
                                                    </button>
                                                    <button onClick={() => handleDelete(item.id)} className="btn btn-sm btn-outline-danger flex-fill font-weight-bold">
                                                        🗑️ Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
